// extracted by mini-css-extract-plugin
export var promotionLink = "_wf-0";